export enum GAMESTATES {
    START_GAME = "START_GAME",
    GETREADY = "GETREADY",
    QUESTIONS = "QUESTIONS",
    SHOW_QUESTION = "SHOW_QUESTION",
    RESTART_QUESTION = "RESTART_QUESTION",
    ENDGAME = "ENDGAME",
}

interface Game {
    state: GAMESTATES;
    question : string;
    options : string[];
    duration: number,
    questionNumber: number,
    percentage1: number,
    percentage2: number,
}

export default Game;
